import { Directive } from '@angular/core';
import { TemplateRefDirective } from 'src/app/utils/template-ref-directive';

@Directive({
    selector: '[appListingTitle]',
    standalone: false
})
export class ListingTitleDirective extends TemplateRefDirective {
}
